// extracted by mini-css-extract-plugin
export var avatarContainer = "_am-0";
export var avatarTypingWave = "_am-i";
export var gray = "_am-f";
export var green = "_am-c";
export var icon = "_am-9";
export var image = "_am-1";
export var lg = "_am-6";
export var md = "_am-5";
export var presenceDot = "_am-b";
export var red = "_am-d";
export var sm = "_am-4";
export var status = "_am-a";
export var typingDot = "_am-h";
export var typingPill = "_am-g";
export var xl = "_am-7";
export var xs = "_am-3";
export var xxl = "_am-8";
export var xxs = "_am-2";
export var yellow = "_am-e";